import { SPECIALISATION_LABELS } from "@/lib/specialisationFields";

// Freelancer Profile Data Audit (2026-02, Phase 3) — shared, read-only display for the
// backend's `specialisation`/gear composites (see modules/build.py's `_specialisation()`/
// `_gear_display()`), reused across all 3 render surfaces (Self/`FreelancerPortal.jsx`,
// Public peer directory/`MemberCard`, PM+Founder/`Build.jsx`) so a freelancer's rich profile
// data looks identical everywhere it's shown, grouped by labelled row (never one flat chip
// pile) per the founder's explicit layout instruction.

export function ChipRow({ label, items, testId, dark }) {
  const values = (Array.isArray(items) ? items : [items]).filter(Boolean);
  if (!values.length) return null;
  return (
    <div data-testid={testId}>
      <div className={`text-[10px] uppercase tracking-wider mb-1.5 ${dark ? "text-white/40" : "text-faint"}`}>{label}</div>
      <div className="flex flex-wrap gap-1.5">
        {values.map((v, i) => <span key={i} className={`rounded-full px-2.5 py-1 text-[11px] ${dark ? "bg-white/10 text-paper/80" : "bg-surface2 text-ink-soft"}`}>{v}</span>)}
      </div>
    </div>
  );
}

// Renders EVERY populated key in `specialisation.role_specific` (niches/services/etc — the
// SAME `_SPECIALISATION_KEYS` set the Interview page's Context zone already surfaces) as its
// own labelled row, so a Cinematographer's "Niches"/"Services" and an Editor's "Film Types"/
// "Other Services" etc. all render correctly without this component needing to know which
// role it's looking at.
export function SpecialisationRows({ specialisation, testIdPrefix = "specialisation" }) {
  const entries = Object.entries(specialisation?.role_specific || {}).filter(([, v]) => (Array.isArray(v) ? v.length : v));
  if (!entries.length) return null;
  return (
    <div className="space-y-3.5" data-testid={`${testIdPrefix}-rows`}>
      {entries.map(([key, value]) => (
        <ChipRow key={key} label={SPECIALISATION_LABELS[key] || key} items={value} testId={`${testIdPrefix}-${key}`} />
      ))}
    </div>
  );
}
